import { useLocalization } from ".";
export const withLocalizationHook = (Component) => {
  return function WrappedComponent(props) {
    const localizationHook = useLocalization();
    return <Component {...props} localizationHook={localizationHook} />;
  }
}